import { useRef, useState } from 'react';

import useResizeObserver from 'hooks/useResizeObserver';

const PortalContainers = () => {
  const stickyStripsContainerRef = useRef<HTMLDivElement>(null);
  const [stickyStripsContainerHeight, setStickyStripsContainerHeight] = useState(0);

  useResizeObserver(stickyStripsContainerRef, () =>
    setStickyStripsContainerHeight(stickyStripsContainerRef?.current?.clientHeight || 0)
  );

  return (
    <>
      <div
        ref={stickyStripsContainerRef}
        className="stickyStripsContainer"
        id="stickyStripsContainer"
      />
      <div className="nonStickyStripsContainer" id="nonStickyStripsContainer" />
      <div
        className="stickyHeadersContainer"
        id="stickyHeadersContainer"
        style={{
          top: stickyStripsContainerHeight,
        }}
      />
    </>
  );
};

export default PortalContainers;
